var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalWrapperChoice',{attrs:{"option":"glyphSacrifice"},on:{"confirm":_vm.handleYesClick},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v(" You are about to sacrifice a Glyph ")]},proxy:true}])},[_c('div',{staticClass:"c-modal-message__text"},[_vm._v(" "+_vm._s(_vm.message)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }